export function addClass(el, className) {
  if (!el || hasClass(el, className)) {
    return
  }
  if (!el.className) {
    el.className = className
    return
  }
  let newClass = el.className.split(' ')
  newClass.push(className)
  el.className = newClass.join(' ')
}

export function hasClass(el, className) {
  let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
  return reg.test(el.className)
}

export function removeClass(el, className) {
  if (!el) return
  let oldClass = ' ' + el.className + ' '
  let newClass = oldClass.replace(' ' + className + ' ', ' ')
  newClass = newClass.replace(/(^\s+)|(\s+$)/g, '')
  el.className = newClass
}

export function toggleClass(el, className) {
  if (hasClass(el, className)) {
    removeClass(el, className)
  } else {
    addClass(el, className)
  }
}

let elementStyle = document.createElement('div').style
// 供应商
let vendor = (() => {
  let transformNames = {
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform',
    standard: 'transform'
  }

  for (let key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      return key
    }
  }

  return false
})()

export function prefixStyle(style) {
  if (vendor === false) return false

  if (vendor === 'standard') return style
  // 运营商 + 首字母大写 + 剩余部分
  return vendor + style.charAt(0).toUpperCase() + style.substr(1)
}

export function isSupportCss(key, attr) {
  let supportCss = {
    aBrowser: ['', '-webkit-'],
    element: document.createElement('div')
  }
  let isSupport = false
  for (var i = 0, j = supportCss.aBrowser.length; i < j; i++) {
    var prefixKey = supportCss.aBrowser[i] + key,
      elm = supportCss.element
    if (prefixKey in elm.style) {
      elm.style[prefixKey] = attr
      isSupport = elm.style[prefixKey] === attr
      if (isSupport) break
    }
  }
  return isSupport
}

export function getScreenSize() {
  let height =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight
  let width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  return {
    height,
    width
  }
}

var lastTime = 0
var vendors = ['webkit']
var requestAnimationFrame, cancelAnimationFrame
for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
  requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
  cancelAnimationFrame =
    window[vendors[x] + 'CancelAnimationFrame'] ||
    window[vendors[x] + 'CancelRequestAnimationFrame']
}

if (!requestAnimationFrame) {
  requestAnimationFrame = function (callback, element) {
    var currTime = new Date().getTime()
    var timeToCall = Math.max(0, 16.7 - (currTime - lastTime))
    var id = setTimeout(function () {
      callback(currTime + timeToCall)
    }, timeToCall)
    lastTime = currTime + timeToCall
    return id
  }
}
if (!cancelAnimationFrame) {
  cancelAnimationFrame = function (id) {
    clearTimeout(id)
  }
}

export function scrollAnimation(currentY, targetY) {
  let needScrollTop = targetY - currentY
  let _currentY = currentY

  requestAnimationFrame(() => {
    const dist = Math.ceil(needScrollTop / 5)
    _currentY += dist
    window.scrollTo(_currentY, currentY)
    if (needScrollTop > 5 || needScrollTop < -5) {
      scrollAnimation(_currentY, targetY)
    } else {
      window.scrollTo(_currentY, targetY)
    }
  })
}

export function getScrollTop() {
  let scrollTop = 0
  let bodyScrollTop = 0
  let documentScrollTop = 0
  if (document.body) {
    bodyScrollTop = document.body.scrollTop
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop
  }
  scrollTop =
    bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop
  return scrollTop
}

export function getScrollHeight() {
  let scrollHeight = 0
  let bodyScrollHeight = 0
  let documentScrollHeight = 0
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight
  }
  scrollHeight =
    bodyScrollHeight - documentScrollHeight > 0
      ? bodyScrollHeight
      : documentScrollHeight
  return scrollHeight
}

export function getWindowHeight() {
  return document.compatMode == 'CSS1Compat'
    ? document.documentElement.clientHeight
    : document.body.clientHeight
}

let positionTop = 0
export function stopBodyScroll(normal) {
  const bodyElm = document.body
  if (normal) {
    positionTop = getScrollTop()

    bodyElm.style.position = 'fixed'
    bodyElm.style.top = -positionTop + 'px'
    bodyElm.style.width = '100%'
    document.documentElement.style.height = (getWindowHeight() - 34) + 'px'
  } else {
    bodyElm.style.position = ''
    bodyElm.style.top = ''
    bodyElm.style.width = ''
    document.documentElement.style.height = ''
    window.scrollTo(0, positionTop)
  }
}

export function getElementLeft(element) {
  var actualLeft = element.offsetLeft
  var current = element.offsetParent
  while (current !== null) {
    actualLeft += current.offsetLeft
    current = current.offsetParent
  }
  return actualLeft
}

export function getElementTop(element) {
  var actualTop = element.offsetTop
  var current = element.offsetParent
  while (current !== null) {
    actualTop += current.offsetTop
    current = current.offsetParent
  }
  return actualTop
}

export function getBoundingClientRect(element) {
  var scrollTop = document.documentElement.scrollTop
  var scrollLeft = document.documentElement.scrollLeft
  if (element.getBoundingClientRect) {
    return element.getBoundingClientRect()
  } else {
    var actualLeft = getElementLeft(element)
    var actualTop = getElementTop(element)
    return {
      left: actualLeft - scrollLeft,
      right: actualLeft + element.offsetWidth - scrollLeft,
      top: actualTop - scrollTop,
      bottom: actualTop + element.offsetHeight - scrollTop
    }
  }
}
